var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatTitle"},[_c('span',{staticClass:"titleName"},[_vm._v(_vm._s(_vm.names))]),_c('el-button',{staticClass:"moreBtn",attrs:{"size":"small","icon":"el-icon-more"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }